import React, { Fragment, useMemo, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Badge, Input, Label, FormGroup, Button } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { MapPin, Check } from 'react-feather';
import moment from 'moment';
import {
    useGetDeliveryZoneRequestsQuery,
    useMarkDeliveryZoneNotifiedMutation,
} from '../../../../store/services/deliveryZoneRequestApi';

const DeliveryZoneRequests = () => {
    const [statusFilter, setStatusFilter] = useState('');

    const { data, isLoading } = useGetDeliveryZoneRequestsQuery({
        limit: 200,
        status: statusFilter || undefined,
    });
    const [markNotified, { isLoading: isMarking }] = useMarkDeliveryZoneNotifiedMutation();

    const requests = useMemo(() => data?.data?.requests || [], [data]);

    const columns = [
        {
            name: 'Requested',
            selector: (row) => moment(row.createdAt).format('DD/MM/YYYY HH:mm'),
            sortable: true,
            width: '160px',
        },
        {
            name: 'Postcode',
            selector: (row) => row.postcode,
            sortable: true,
            width: '120px',
            cell: (row) => <span className="fw-bold">{row.postcode}</span>,
        },
        {
            name: 'Suburb',
            selector: (row) => row.suburb || '—',
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row) => row.email,
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
            sortable: true,
            width: '130px',
            cell: (row) => (
                <Badge color={row.status === 'notified' ? 'success' : 'warning'} pill>
                    {row.status === 'notified' ? 'Notified' : 'Pending'}
                </Badge>
            ),
        },
        {
            name: 'Action',
            width: '160px',
            cell: (row) =>
                row.status === 'notified' ? (
                    <span className="text-muted small">Done</span>
                ) : (
                    <Button
                        color="light"
                        size="sm"
                        disabled={isMarking}
                        onClick={() => markNotified(row._id)}
                    >
                        <Check size={14} className="text-success me-1" />
                        Mark notified
                    </Button>
                ),
        },
    ];

    return (
        <Fragment>
            <Breadcrumbs mainTitle="Delivery Zone Requests" parent="customers" title="Notify Me Requests" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card className="shadow-sm">
                            <CardHeader className="bg-white border-bottom py-3">
                                <h5 className="mb-1">
                                    <MapPin size={20} className="text-secondary me-2" />
                                    Customers waiting on delivery
                                </h5>
                                <p className="text-muted mb-0 small">
                                    Postcodes customers asked to be notified about once we deliver there.
                                </p>
                            </CardHeader>
                            <CardBody>
                                <div className="mb-4 bg-light p-3 rounded-3 d-flex gap-3 align-items-end flex-wrap border">
                                    <FormGroup className="mb-0">
                                        <Label className="small fw-bold text-muted mb-1">STATUS</Label>
                                        <Input
                                            type="select"
                                            size="sm"
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                            className="border-secondary-subtle"
                                        >
                                            <option value="">All</option>
                                            <option value="pending">Pending</option>
                                            <option value="notified">Notified</option>
                                        </Input>
                                    </FormGroup>
                                </div>

                                <DataTable
                                    columns={columns}
                                    data={requests}
                                    pagination
                                    progressPending={isLoading}
                                    highlightOnHover
                                    striped
                                    responsive
                                    noDataComponent={
                                        <div className="p-5 text-center text-muted">No delivery zone requests yet.</div>
                                    }
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default DeliveryZoneRequests;
